/**
 * Simple stats tracker for FPS and rendering metrics
 */
export class Stats {
  public fps: number = 0;
  private frameCount: number = 0;
  private lastTime: number = performance.now();

  /**
   * Update stats
   */
  public update(): void {
    const now = performance.now();
    const delta = now - this.lastTime;

    this.frameCount++;

    // Update FPS every 500ms
    if (delta >= 500) {
      this.fps = Math.round((this.frameCount * 1000) / delta);
      this.frameCount = 0;
      this.lastTime = now;
    }
  }

  /**
   * Reset stats
   */
  public reset(): void {
    this.fps = 0;
    this.frameCount = 0;
    this.lastTime = performance.now();
  }
}
